// extracted by mini-css-extract-plugin
module.exports = {"workedHours":"_2aiPY","comments":"_1hLT-","comment":"_35xnG","actions":"_1wzCN","label":"_3wDrA","buttons":"_3qavs","button":"_3gViU","replaceButton":"_35gw5"};